<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
    <p style="color: white">
      Loading... </p>
  </ngx-spinner>
  <div class="card">
    <div class="card-header">
      <table style="width:100%">
        <td style="width:40%">
          <h2 class="text-primary">BRD Summary Report {{year_S.yearDesc}}</h2>
        </td>
        <td style="width:20%">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>กรุณาเลือกปี </mat-label>
            <mat-select disableRipple required [(ngModel)]="year_S" (selectionChange)="select_year()">
              <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
              <mat-option *ngFor="let item of year_L" [value]="item">
                {{item.yearDesc}}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <button mat-raised-button color="primary" (click)="select_year()">ตกลง/โหลดใหม่</button>
        </td>
        <td>
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
          <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
          </button>
          <!-- <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
              </button> -->
        </td>
      </table>
      <!--<div class="card-tools">
      </div>-->
    </div>
    <div class="card-body">
      <!-- แบบใหม่กว่า  -->
      <div class="card">
        <ul class="nav nav-pills justify-content-center" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="btn btn-outline-success" [ngClass]="{'active':m_id == 'sv'}" (click)="to_sum('sv')">
              <h4>นอส. <i class="far fa-address-card"></i></h4>
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="btn btn-outline-success" [ngClass]="{'active':m_id == 'ld'}" (click)="to_sum('ld')">
              <h4>ผจก./ส่วน<i class="far fa-address-book"></i></h4>
            </a>
          </li>
          <!--<li class="nav-item" role="presentation">
            <a class="btn btn-outline-success" [ngClass]="{'active':m_id == 'ad'}" (click)="to_sum('ad')">
              <h4>ออดิต<i class="fas fa-ad"></i></h4>
            </a>
          </li>-->
        </ul>
        <div class="row justify-content-center">
          <div class="col-md-3">
            <div class="card card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-warning">
                  <div class="inner">
                    <h4 style="font-weight: bold;text-align:center;">ประเมิน {{brdsummary.asNow | number}} ตัน</h4>
                  </div>
                  <div class="icon"> <i class="fas fa-chart-bar"></i> </div>
                </div>
              </div>
              <div class="card-body">
                <div class="progress-group">
                  {{brdsummary.pc_asNow}}%
                  <span class="float-right"><b>{{brdsummary.asNow | number }}</b>/{{ brdsummary.tarAsNow | number
                    }}</span>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-primary" [style.width]="brdsummary.pc_asNow+'%'"></div>
                  </div>
                </div>
              </div>
              <div class="card-footer w3-center txtLarger bg-warning">
                last update : {{ lastupdate | adtob }}
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-danger">
                  <div class="inner">
                    <h4 style="font-weight: bold;text-align:center;">อ้อยคงเหลือหักสูญเสีย {{brdsummary.asLeft |
                      number}} ตัน
                    </h4>
                  </div>
                  <div class="icon"> <i class="	fas fa-chart-bar"></i> </div>
                </div>
              </div>
              <div class="card-body">
                <div class="progress-group">
                  {{brdsummary.pc_asLeft}}%
                  <span class="float-right"><b>{{brdsummary.asLeft | number }}</b>
                    /{{ brdsummary.tarAsNow | number }}</span>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-primary" [style.width]="brdsummary.pc_asLeft+'%'"></div>
                  </div>
                </div>
              </div>
              <div class="card-footer w3-center txtLarger bg-danger">
                ( ตัดพันธุ์ {{ brdsummary.cutseed | number}} ตัน ),
                <br> ( ตันสูญเสีย {{ brdsummary.caneLost | number}} ตัน )
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-info">
                  <div class="inner">
                    <h4 style="font-weight: bold;text-align:center;">ผลผลิต {{brdsummary.yieldLeft | number}}
                      ตัน/ไร่
                    </h4>
                  </div>
                  <div class="icon"> <i class="	fas fa-heartbeat"></i> </div>
                </div>
              </div>
              <div class="card-body">
                <div class="progress-group">
                  {{brdsummary.pc_yieldNow}}%
                  <span class="float-right"><b>{{brdsummary.yieldLeft | number }}</b>/{{ brdsummary.tarYieldNow |
                    number }}</span>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-primary" [style.width]="brdsummary.pc_yieldNow+'%'"></div>
                  </div>
                </div>
              </div>
              <div class="card-footer w3-center txtLarger bg-info">
                ผลผลิต ปี {{brdsummary.year_p}}: {{brdsummary.yield_p | number }} (ตัน/ไร่)
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="card card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-success">
                  <div class="inner">
                    <h4 style="font-weight: bold;text-align:center;">พื้นที่คงเหลือ {{brdsummary.areaLeft | number}}
                      ไร่
                    </h4>
                  </div>
                  <div class="icon">
                    <i class="fas fa-map-marked-alt"></i>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="progress-group">
                  {{brdsummary.pc_areaLeft}}%
                  <span class="float-right"><b>{{brdsummary.areaLeft | number }}</b>/{{ brdsummary.tarArea | number
                    }}</span>
                  <div class="progress progress-sm">
                    <div class="progress-bar bg-primary" [style.width]="brdsummary.pc_areaLeft+'%'"></div>
                  </div>
                </div>
              </div>
              <div class="card-footer w3-center txtLarger bg-success">
                (**พื้นที่สูญเสีย {{brdsummary.areaLost | number}} (ไร่))
              </div>
            </div>
          </div>
        </div>
        <!-- <p class="txtSmall w3-left" style="text-align:left; color: red;">***หักพื้นที่สูญเสียแล้ว</p> -->
      </div>

      <div class="card card-primary card-outline">
        <ul class="nav nav-pills mb-3 d-flex justify-content-around" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="btn btn-outline-primary active" data-toggle="tab" role="tab" aria-selected="true"
              (click)="data_esp(1);" aria-controls="ex2-tabs-1">
              <h4>พื้นที่ปลูก(ไร่) <i class="fas fa-arrow-circle-down"></i></h4>
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="btn btn-outline-primary" data-toggle="tab" role="tab" aria-selected="true" (click)="data_esp(2);"
              aria-controls="ex2-tabs-1">
              <h4>ปริมาณอ้อย(ตัน) <i class="fas fa-arrow-circle-down"></i></h4>
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="btn btn-outline-primary" data-toggle="tab" role="tab" aria-selected="true" (click)="data_esp(3);"
              aria-controls="ex2-tabs-1">
              <h4>ผลผลิต(ตัน/ไร่) <i class="fas fa-arrow-circle-down"></i></h4>
            </a>
          </li>
        </ul>

        <div class="card-body">
          <div class="container">
            <div id="chart-pie" style="align-items: center; width: 100%; height:600px;"></div>
          </div>
        </div>
      </div>

      <div class="card card-primary card-outline">
        <div class="card-header">
          <div class="row">
            <div class="col-md-auto">
              <p class="headText2 text-primary" style="font-size: xx-large;">
                <i class="fas fa-caret-left"></i>สรุปประเมินรายวัน {{data_select.d1|adtob}} - {{data_select.d2|adtob}}
              </p>
            </div>
            <div class="col-md-auto">
              <mat-form-field appearance="fill">
                <mat-label>ช่วงวันที่</mat-label>
                <mat-date-range-input [rangePicker]="picker" disabled>
                  <input matStartDate [(ngModel)]="data_select.d1" placeholder="วันที่เริ่มต้น">
                  <input matEndDate [(ngModel)]="data_select.d2" placeholder="ถึงวันที่">
                </mat-date-range-input>
                <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              </mat-form-field>
            </div>
            <div class="col-md-auto">
              <button mat-raised-button (click)="Load_sum_informarea();">ตกลง/Refresh</button>
            </div>
            <div class="col-md-auto">
              <mat-form-field appearance="fill">
                <mat-label>เลือก</mat-label>
                <mat-select (selectionChange)="cra_informarea_Chart($event.value)">
                  <mat-option *ngFor="let dt of list_p" [value]="dt">{{dt}} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="card-body" *ngIf="informarea_Charts && list_supcode.length">
          <div *ngFor="let supcode of list_supcode">
            <h4>{{ supcode }}</h4>
            <div echarts [options]="informarea_Charts[supcode]" style="width: 100%; min-height: 400px;"></div>
          </div>
        </div>
      </div>

      <!--กิจกรรม KPI มอนิเตอร์ตามอายุ-->
      <div class="card card-primary card-outline" *ngIf="KpiMn.length>0">
        <div class="card-header">
          <div class="row justify-content-center">
            <div class="col-6" style="text-align:left">
              <p class="headText2 text-primary" style="font-size: xx-large;">
                <i class="fas fa-heartbeat"></i>กิจกรรมหลัก Burirum Model {{year_S.yearDesc}} - {{supcode_Kpi[0]}}
              </p>
              <label class=""> (เฉพาะพื้นที่ ปลูกเสร็จ) </label>
            </div>
            <div class="col-sm-2" style="text-align:center">
              <mat-form-field appearance="fill">
                <mat-label>เลือก นอส</mat-label>
                <mat-select (selectionChange)="Load_kpiActivity2($event.value, supcode_Kpi[1])">
                  <mat-option *ngFor="let dt of supcode_Kpi_ls" [value]="dt">{{dt}} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col" style="text-align:right">
              <div class="card-tools">
                <button type="button" class="btn btn-tool" (click)="Load_kpiActivity(year_S.yearCr)">
                  <i class="fas fa-sync"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                  <i class="fas fa-minus"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
                </button>
                <!-- <button type="button" class="btn btn-tool" data-card-widget="remove">
                  <i class="fas fa-times"></i>
                </button> -->
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-4 col-sm-2">
              <div class="nav flex-column nav-pills ggPrompt" id="kpimenu" role="tablist" aria-orientation="vertical">
                <a class="nav-link" role="tab" aria-selected="false" disabled>แยกตามอายุ</a>
                <a class="nav-link active" data-toggle="pill" role="tab" aria-selected="true"
                  (click)="Load_kpiActivity2(supcode_Kpi[0],'5')">ทั้งหมด</a>
                <a class="nav-link" data-toggle="pill" role="tab" aria-selected="true"
                  (click)="Load_kpiActivity2(supcode_Kpi[0],'1')">0-30 วัน</a>
                <a class="nav-link" data-toggle="pill" role="tab" aria-selected="true"
                  (click)="Load_kpiActivity2(supcode_Kpi[0],'2')">31-60 วัน</a>
                <a class="nav-link" data-toggle="pill" role="tab" aria-selected="true"
                  (click)="Load_kpiActivity2(supcode_Kpi[0],'3')">61-90 วัน</a>
                <a class="nav-link" data-toggle="pill" role="tab" aria-selected="true"
                  (click)="Load_kpiActivity2(supcode_Kpi[0],'4')">มากกว่า 90 วัน</a>
              </div>
            </div>
            <div class="col-8 col-sm-10">
              <div class="chart">
                <!-- <canvas #barCanvas></canvas> -->
                <chart [type]="typeChart" [data]="dataChart" [options]="optionsChart"></chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--แปลงอ้อย-->
      <div class="card card-primary card-outline card-tabs" *ngIf="ArealevelOMonth.length">
        <div class="card-header">
          <p class="headText2 text-primary" style="font-size: xx-large;">
            <i class="fas fa-tree"></i> แปลงอ้อย {{year_S.yearDesc}}
          </p>
        </div>
        <div class="card-body">
          <ul class="nav nav-tabs ggPrompt" id="custom-tabs-three-tab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill"
                href="#custom-tabs-three-home" role="tab" aria-selected="true">ประเมิน</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-gradeA-tab" data-toggle="pill" href="#custom-tabs-gradeA" role="tab"
                (click)="call_gradeYield('All')" aria-selected="false">แปลงเกรด
                A</a>
            </li>
            <!--<li class="nav-item">
              <a class="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill"
                href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile"
                aria-selected="false">BRR Model</a>
            </li>-->
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-three-settings-tab" data-toggle="pill"
                href="#custom-tabs-three-settings" role="tab" aria-selected="false">ระดับพื้นที่</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-three-cpupdate-tab" data-toggle="pill"
                href="#custom-tabs-three-cpupdate" role="tab" aria-selected="false">การอัพเดต</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-three-messages-tab" data-toggle="pill"
                href="#custom-tabs-three-messages" role="tab" aria-selected="false">โรคแมลง</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-three-cpseed-tab" data-toggle="pill" href="#custom-tabs-three-cpseed"
                role="tab" aria-selected="false">พันธุ์อ้อย</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-three-cpc-tab" data-toggle="pill" href="#custom-tabs-three-cpc"
                role="tab" aria-selected="false">คิวอ้อย</a>
            </li>
          </ul>
          <div class="tab-content" id="custom-tabs-three-tabContent">
            <div class="tab-pane fade show active" id="custom-tabs-three-home" role="tabpanel"
              aria-labelledby="custom-tabs-three-home-tab">
              <div class="chart-container">
                <!-- แผนภูมิ การประเมินอ้อยแต่ละครั้ง -->
                <chart [type]="estimateTypeChart" [data]="estimateCaneChartData" [options]="estimateCaneChartOption">
                </chart>
              </div>
            </div>
            <div class="tab-pane fade" id="custom-tabs-gradeA" role="tabpanel" aria-labelledby="custom-tabs-gradeA-tab">
              <div class="leaderboard">
                <div class="row justify-content-around">
                  <div class="col-md-9 d-flex align-items-center">
                    <div class="chart-container">
                      <div id="chart-pie-chart_grade" style="align-items: center; width: 100%;height:420px;">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 d-flex align-items-center">
                    <div class="d-flex justify-content-between">
                      <table>
                        <tr style="text-align:center">
                          <td [colSpan]="4">ใช้ประเมิน ตัน/ไร่ รายแปลง</td>
                        </tr>
                        <tr style="text-align:center">
                          <td>เกรด Yield</td>
                          <th>ER</th>
                          <th>ST</th>
                          <th>SR</th>
                        </tr>
                        <tr style="text-align:center">
                          <th>A</th>
                          <td>&gt;=15</td>
                          <td>&gt;=11</td>
                          <td>&gt;=13</td>
                        </tr>
                        <tr style="text-align:center">
                          <th>B</th>
                          <td>12-14</td>
                          <td>9-10</td>
                          <td>11-12</td>
                        </tr>
                        <tr style="text-align:center">
                          <th>C</th>
                          <td>&lt;12</td>
                          <td>&lt;9</td>
                          <td>&lt;11</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <h4>Leaderboard</h4>
                <div class="example-action-buttons">
                  <mat-button-toggle-group name="favoriteColor" aria-label="Favorite Color">
                    <mat-button-toggle (click)="accordion.openAll()">openAll</mat-button-toggle>
                    <mat-button-toggle (click)="accordion.closeAll()">closeAll</mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                <mat-accordion class="example-headers-align" multi>
                  <mat-expansion-panel *ngFor="let dt of data_gradeYield_sum; let i = index;"
                    (opened)="panelState = true" (closed)="panelState = false">
                    <mat-expansion-panel-header (click)="data_esp(6, dt.supzone)">
                      <mat-panel-title>
                        <table style="width: 100%;">
                          <tr style="text-align:center">
                            <td style="width:20%;">
                              <div class="d-flex">รวม : {{ dt.supzone }}</div>
                            </td>
                            <td style="width:10%;">
                              <span class="badge badge-secondary align-items-center"> {{ dt.cnt_sub }} </span>
                            </td>
                            <td style="width:70%;">
                              <div class="ml-auto p-2 d-flex align-items-center" *ngIf="dt.supzone!='All'">
                                <div class="d-flex justify-content-center" style="text-align:center"
                                  *ngFor="let dts of filter_data_grade(dt.supzone);">
                                  <img src="{{ dts.suppic_url }}" alt="" height="45px" *ngIf="dts.suppic_url!=NULL">
                                </div>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </mat-panel-title>
                      <mat-panel-description>
                        <table style="width: 100%;">
                          <tr style="text-align:center">
                            <td style="width:25%;">
                              เกรด A <b>{{ dt.gA | number }}</b> แปลง
                              <span class="badge bg-primary">{{ dt.pc_gA | number:'1.1-2'}}%</span>
                              <mat-progress-bar color="primary" mode="determinate"
                                value="{{ dt.pc_gA }}"></mat-progress-bar>
                            </td>
                            <td style="width:25%;">
                              เกรด B <b>{{ dt.gB | number }}</b> แปลง
                              <span class="badge bg-info">{{ dt.pc_gB | number:'1.1-2'}}%</span>
                              <mat-progress-bar color="primary" mode="determinate"
                                value="{{ dt.pc_gB }}"></mat-progress-bar>
                            </td>
                            <td style="width:25%;">
                              เกรด C <b>{{ dt.gC | number }}</b> แปลง
                              <span class="badge bg-warning">{{ dt.pc_gC | number:'1.1-2'}}%</span>
                              <mat-progress-bar color="primary" mode="determinate"
                                value="{{ dt.pc_gC }}"></mat-progress-bar>
                            </td>
                            <td>พื้นที่รวม {{dt.landvalue | number:'1.1-2' }}ไร่</td>
                          </tr>
                        </table>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <table style="width: 100%;">
                      <thead>
                        <tr style="text-align:center">
                          <th>#</th>
                          <th></th>
                          <th>ชื่อ</th>
                          <th>โซน</th>
                          <th>เกรด A</th>
                          <th>เกรด B</th>
                          <th>เกรด C</th>
                          <th>พื้นที่รวม</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dts of filter_data_grade(dt.supzone); let i = index;" style="text-align:center">
                          <td>{{ i + 1 }}</td>
                          <td>
                            <img src="{{ dts.suppic_url }}" alt="" height="45px" *ngIf="dts.suppic_url">
                          </td>
                          <td>{{ dts.supcode }}:{{ dts.supname }}</td>
                          <td>{{ dts.supzone }}</td>
                          <td>{{ dts.gA | number }} แปลง
                            <span class="badge bg-primary">{{ dts.pc_gA | number:'1.1-2'}}%</span>
                            <mat-progress-bar color="accent" mode="determinate"
                              value="{{ dts.pc_gA }}"></mat-progress-bar>
                          </td>
                          <td>{{ dts.gB | number }} แปลง
                            <span class="badge bg-info">{{ dts.pc_gB | number:'1.1-2' }}%</span>
                            <mat-progress-bar color="accent" mode="determinate"
                              value="{{ dts.pc_gB }}"></mat-progress-bar>
                          </td>
                          <td>{{ dts.gC | number }} แปลง
                            <span class="badge bg-warning">{{ dts.pc_gC | number:'1.1-2'}}%</span>
                            <mat-progress-bar color="accent" mode="determinate"
                              value="{{ dts.pc_gC }}"></mat-progress-bar>
                          </td>
                          <td>{{ dts.landvalue | number:'1.1-2' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>

            </div>
            <div class="tab-pane fade" id="custom-tabs-three-profile" role="tabpanel"
              aria-labelledby="custom-tabs-three-profile-tab">
              <div class="chartx">
                <div class="row d-flex mt-2 mb-1">
                  <h4 class="card-header bg-info text-center">
                    <span class="ggPrompt">แปลงอ้อย BRR Model 4 ปีการผลิต</span>
                  </h4>
                </div>
                <div class="row d-flex mt-1">
                  <div class="col border-s1 borderdot mx-1">
                    <!-- <div class="p-2 mt-2 bg-warning ggPrompt text-center">ปี 66/67</div> -->
                    <div class="chart-container">
                      <div class="small-box">
                        <div class="icon">
                          <i class="far fa-arrow-alt-circle-down"></i>
                        </div>
                      </div>
                      <canvas id="mixChart" style="height:40vh; width:40vw"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="custom-tabs-three-settings" role="tabpanel"
              aria-labelledby="custom-tabs-three-settings-tab">
              <div class="chart-container">
                <!-- แผนภูมิ ระดับพื้นที่-->
                <canvas id="ArealevelChartM" style="height:25vh; width:45vw"> </canvas>
              </div>
            </div>
            <div class="tab-pane fade" id="custom-tabs-three-cpupdate" role="tabpanel"
              aria-labelledby="custom-tabs-three-cpupdate-tab">
              <!-- แผนภูมิ การอัพเดตกิจกรรมแปลง ประจำเดือน -->
              <div class="row mt-2 mb-2">
                <div class="col borderdot mx-1 d-flex justify-content-around">
                  <!-- <span>cpmUpdateData : {{ cpmUpdateData | json }}</span> -->
                  <canvas id="cpupdataDiary" style="height:20vh; width:40vw"></canvas>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col borderdot mx-1 d-flex justify-content-around">
                  <ngx-charts-pie-grid *ngIf="saleData" [results]="saleData" [view]="view1">
                  </ngx-charts-pie-grid>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="custom-tabs-three-messages" role="tabpanel"
              aria-labelledby="custom-tabs-three-messages-tab">

              <div class="row">
                <div class="col-md-6">
                  <div class="container borderdash" style="align-items: center;">
                    <div id="chart-pie-Disease" style="align-items: center; width: 650px;height:500px;"></div>
                  </div>
                  <div class="card p-0 mt-2 borderdash">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr style="text-align:center">
                          <th style="width:25%">งวด</th>
                          <th style="width:25%">โรค</th>
                          <th style="width:25%">จำนวนแปลง</th>
                          <th style="width:25%">พื้นที่(ไร่)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style="text-align:center" *ngFor="let dt of data_Disease">
                          <td>กิจกรรมงวดที่ {{dt.p0}}</td>
                          <td>{{dt.desc}}</td>
                          <td><a class="badge bg-danger">{{dt.cnt | number}}</a></td>
                          <td><a class="badge bg-warning">{{dt.landvalue | number}}</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="container borderdash" style="align-items: center;">
                    <div id="chart-pie-Insect" style="align-items: center; width: 650px;height:500px;"></div>
                  </div>
                  <div class="card p-0 mt-2 borderdash">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr style="text-align:center">
                          <th style="width:25%">งวด</th>
                          <th style="width:25%">แมลง</th>
                          <th style="width:25%">จำนวนแปลง</th>
                          <th style="width:25%">พื้นที่(ไร่)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style="text-align:center" *ngFor="let dt of data_Insect">
                          <td>กิจกรรมงวดที่ {{dt.p0}}</td>
                          <td>{{dt.desc}}</td>
                          <td><a class="badge bg-danger">{{dt.cnt | number}}</a></td>
                          <td><a class="badge bg-warning">{{dt.landvalue | number}}</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <div class="chart">
                      <span>อยู่ระหว่างพัฒนา</span>
                       แผนภูมิ โรคแมลง 
                       <chart [type]="estimateTypeChart" [data]="estimateCaneChartData"
                        [options]="estimateCaneChartOption"></chart> 
                    </div>-->
            </div>
            <div class="tab-pane fade" id="custom-tabs-three-cpseed" role="tabpanel"
              aria-labelledby="custom-tabs-three-cpseed-tab">
              <!--<div class="chart-container">
                      แผนภูมิ สัดส่วนพันธุ์อ้อย
                      <chart [type]="seedcaneratioTypeChart" [data]="seedcaneratioCaneChartData"
                        [options]="seedcaneratioCaneChartOption">
                      </chart>
                    </div>-->
              <div class="card p-0 mt-2 borderdash" style="align-items: center;">
                <div class="container">
                  <div id="chart-pie-seedcane" style="align-items: center; width: 1200px;height:650px;"></div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="custom-tabs-three-cpc" role="tabpanel"
              aria-labelledby="custom-tabs-three-cpc-tab">
              <div class="row d-flex mt-2 mb-1">
                <h4 class="card-header bg-info text-center">
                  <span class="ggPrompt">การจัดกลุ่มคิวแปลงอ้อย</span>
                </h4>
              </div>
              <div class="card p-0 mt-2 borderdash">
                <!-- แผนภูมิ การจัดคิวอ้อยของแปลงอ้อย -->
                <!--<ngx-charts-advanced-pie-chart [view]="view" [scheme]="colorScheme" [results]="single"
                          [gradient]="gradient">
                        </ngx-charts-advanced-pie-chart>-->
                <div class="row">
                  <div class="col-md-9" style="align-items: center;">
                    <div class="container">
                      <div id="chart-pie-groupQ" style="align-items: center; width: 900px;height:550px;"></div>
                    </div>
                  </div>
                  <div class="col-md-3" style="align-items: center;">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr style="text-align:center">
                          <th><a class="nav-link">ประเภทคิว</a>
                          </th>
                          <th><a class="nav-link">ปริมาณตัน</a> </th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- qdesc, assess -->
                        <tr style="text-align:center" *ngFor="let item of cpgroupqdata">
                          <td>
                            <a class="nav-link"> {{item.qdesc}} </a>
                          </td>
                          <td>
                            <a class="badge badge-secondary"> {{item.assess | number}} </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ชาวไร่ -->
      <div class="card card-primary card-outline" *ngFor="let dt of sumCntFmSum">
        <div class="card-header">
          <div class="row">
            <div class="col-md-8">
              <p class="headText2 text-primary" style="font-size: xx-large;">
                <i class="fas fa-user"></i> ชาวไร่ {{dt.cnt | number}} ราย
              </p>
            </div>
            <div class="col-md-4 text-right ggPrompt">
              <p class=""> (ที่มีพื้นที่ {{year_S.yearDesc}}) </p>
            </div>
          </div>
          <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="LoadsumCntFm(year_S.yearCr)">
              <i class="fas fa-sync"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
              <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
            </button>
          </div>
        </div>
        <div class="card-body headText">
          <div class="row">
            <div class="col card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-warning">
                  <div class="inner">
                    <h1 class="headText2">ปริมาณอ้อย (ตัน)</h1>
                    <!-- <p class="text-white headText">cane projection</p> -->
                  </div>
                  <div class="icon">
                    <i class="fas fa-chart-bar"></i>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <!--<canvas id="fmCaneValueChart"></canvas>-->
                <div id="chart-pie-Assess-fm" style="align-items: center; height: 220px; width: 100%;"></div>
              </div>
              <div class="card-footer p-0 mt-2 borderdash">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr class="headText" style="text-align:center">
                      <th>ช่วงปริมาณอ้อย(ตัน)</th>
                      <th>จำนวนชาวไร่</th>
                      <th>%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let range of data_Line.Assess_data[0]; let i = index" style="text-align:center">
                      <td style="text-align:left">&nbsp;&nbsp;{{ range }}</td>
                      <td>{{ data_Line.Assess_data[1][i] | number}}</td>
                      <td>{{ getPercentage(data_Line.Assess_data[1][i],dt.cnt) | number:'1.2-2'}}%</td>
                    </tr>
                  </tbody>
                </table>


              </div>
              <hr>
            </div>

            <div class="col card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-info">
                  <div class="inner">
                    <h1 class="headText2">ผลผลิต (ตัน/ไร่) </h1>
                    <!-- <p class="text-white headText">cane projection</p> -->
                  </div>
                  <div class="icon">
                    <i class="	fas fa-heartbeat"></i>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <!--<canvas id="fmCaneYieldChart"></canvas>-->
                <div id="chart-pie-yield-fm" style="align-items: center; height: 220px; width: 100%;"></div>
              </div>
              <div class="card-footer p-0 mt-2 borderdash">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr class="headText" style="text-align:center">
                      <th>ระดับผลผลิต</th>
                      <th [colSpan]="2">จำนวนชาวไร่</th>
                      <th [colSpan]="2">จำนวนแปลง</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let range of data_Line.yield_data[0]; let i = index" style="text-align:center">
                      <td style="text-align:left">&nbsp;&nbsp;{{ range }}</td>
                      <td>{{ data_Line.yield_data[1][i] | number}}</td>
                      <td>{{ getPercentage(data_Line.yield_data[1][i],dt.cnt) | number:'1.2-2'}}%</td>
                      <td>{{ data_Line.yield_data[2][i] | number}}</td>
                      <td>{{ getPercentage(data_Line.yield_data[2][i],dt.cntcp) | number:'1.2-2'}}%</td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <hr>
            </div>

            <div class="col card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-success">
                  <div class="inner">
                    <h1 class="headText2">พื้นที่ปลูก (ไร่)</h1>
                    <!-- <p class="text-white headText">cane projection</p> -->
                  </div>
                  <div class="icon">
                    <i class="fas fa-map-marked-alt"></i>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <!--<canvas id="fmCaneAreaChart"></canvas>-->
                <div id="chart-pie-area-fm" style="align-items: center; height: 220px; width: 100%;"></div>
              </div>
              <div class="card-footer p-0 mt-2 borderdash">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr class="headText" style="text-align:center">
                      <th>ช่วงพื้นที่ปลูก(ไร่)</th>
                      <th>จำนวนชาวไร่</th>
                      <th>%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let range of data_Line.area_data[0]; let i = index" style="text-align:center">
                      <td style="text-align:left">&nbsp;&nbsp;{{ range }}</td>
                      <td>{{ data_Line.area_data[1][i] | number}}</td>
                      <td>{{ getPercentage(data_Line.area_data[1][i],dt.cnt) | number:'1.2-2'}}%</td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <hr>
            </div>

            <div class="col card-widget widget-user-2">
              <div class="card-header p-0">
                <div class="small-box bg-primary">
                  <div class="inner">
                    <h1 class="headText2">เกรดชาวไร่(คน)</h1>
                    <!-- <p class="text-white headText">cane projection</p> -->
                  </div>
                  <div class="icon">
                    <i class="fas fa-map-marked-alt"></i>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div id="chart-pie-grade-fm" style="align-items: center; height: 220px; width: 100%;"></div>
              </div>
              <div class="card-footer p-0 mt-2 borderdash">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr class="headText" style="text-align:center">
                      <th>เกรดชาวไร่</th>
                      <th>จำนวนชาวไร่</th>
                      <th>%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let range of data_Line.grade_data[0]; let i = index" style="text-align:center">
                      <td style="text-align:left">&nbsp;&nbsp;{{ range }}</td>
                      <td>{{ data_Line.grade_data[1][i] | number}}</td>
                      <td>{{ getPercentage(data_Line.grade_data[1][i],dt.cnt) | number:'1.2-2'}}%</td>
                    </tr>
                  </tbody>
                </table>
                <!--<table class="table table-sm" style="height:50%">
                  <thead>
                    <tr style="text-align:right">
                      <th style="text-align:left"><a class="nav-link">เกรดชาวไร่</a></th>
                      <th style="text-align:center"><a class="nav-link">จำนวนชาวไร่</a> </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="text-align:right">
                      <td style="text-align:left"><a class="nav-link">ชาวไร่ เกรด A </a></td>
                      <td style="text-align:center"><a class="badge bg-primary">{{dt.grade_A | number}}</a><a
                          class="badge bg-light">{{((dt.grade_A * 100) / dt.cnt_grade).toFixed(2)}}%</a> </td>
                    </tr>
                    <tr style="text-align:right">
                      <td style="text-align:left"><a class="nav-link">ชาวไร่ เกรด B </a>
                      </td>
                      <td style="text-align:center"><a class="badge bg-success">{{dt.grade_B | number}}</a><a
                          class="badge bg-light">{{((dt.grade_B * 100) / dt.cnt_grade).toFixed(2)}}%</a></td>
                    </tr>
                    <tr style="text-align:right">
                      <td style="text-align:left"><a class="nav-link">ชาวไร่ เกรด C </a>
                      </td>
                      <td style="text-align:center"><a class="badge bg-info">{{dt.grade_C | number}}</a><a
                          class="badge bg-light">{{((dt.grade_C * 100) / dt.cnt_grade).toFixed(2)}}%</a></td>
                    </tr>
                    <tr style="text-align:right">
                      <td style="text-align:left"><a class="nav-link">ชาวไร่ เกรด D </a>
                      </td>
                      <td style="text-align:center"><a class="badge bg-warning">{{dt.grade_D | number}}</a><a
                          class="badge bg-light"> {{((dt.grade_D * 100) / dt.cnt_grade).toFixed(2)}}%</a></td>
                    </tr>
                    <tr style="text-align:right">
                      <td style="text-align:left"><a class="nav-link">ชาวไร่ เกรด F </a>
                      </td>
                      <td style="text-align:center"><a class="badge bg-danger">{{dt.grade_F | number}}</a><a
                          class="badge bg-light"> {{((dt.grade_F * 100) / dt.cnt_grade).toFixed(2)}}%</a></td>
                    </tr>
                  </tbody>
                </table>-->
              </div>
              <hr>
            </div>
          </div>
        </div>
      </div>

      <!-- โรค/แมลง  -->
      <!--<div class="row">
            <div class="col-md-12">            
              <div class="card card-primary card-outline">
                <div class="card-header">
                  <p class="headText2 text-primary" style="font-size: xx-large;"> <i class="fas fa-bug"></i> โรค/แมลง </p>
                  <span class="text-red">...อยู่ระหว่างพัฒนา</span>                    
                </div>

              </div>
            </div>
          </div>-->

      <!-- สินเชื่อ -->
      <!--  
          <div class="row">
            <div class="col-12">
              <div class="card card-primary card-outline">
                <div class="card-header">
                    <p class="headText text-primary" style="font-size: xx-large;"> <i class="fas fa-money-check-alt"></i> สินเชื่อ</p>
                    <span class="text-red">...อยู่ระหว่างพัฒนา</span>
                  </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <div class="card">
                        <div class="card-header border-0">
                          <h4 class="card-title">Products</h4>
                          <div class="card-tools">
                            <a href="#" class="btn btn-tool btn-sm">
                              <i class="fas fa-download"></i>
                            </a>
                            <a href="#" class="btn btn-tool btn-sm">
                              <i class="fas fa-bars"></i>
                            </a>
                          </div>
                        </div>
                        <div class="card-body">
                          <table class="table table-lg">
                            <thead>
                              <tr>
                                <th style="width: 10px">#</th>
                                <th>Task</th>
                                <th>Progress</th>
                                <th style="width: 40px">Label</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1.</td>
                                <td>Update software</td>
                                <td>
                                  <div class="progress progress-xs">
                                    <div class="progress-bar progress-bar-danger" style="width: 55%"></div>
                                  </div>
                                </td>
                                <td><span class="badge bg-danger">55%</span></td>
                              </tr>
                              <tr>
                                <td>2.</td>
                                <td>Clean database</td>
                                <td>
                                  <div class="progress progress-xs">
                                    <div class="progress-bar bg-warning" style="width: 70%"></div>
                                  </div>
                                </td>
                                <td><span class="badge bg-warning">70%</span></td>
                              </tr>
                              <tr>
                                <td>3.</td>
                                <td>Cron job running</td>
                                <td>
                                  <div class="progress progress-xs progress-striped active">
                                    <div class="progress-bar bg-primary" style="width: 30%"></div>
                                  </div>
                                </td>
                                <td><span class="badge bg-primary">30%</span></td>
                              </tr>
                              <tr>
                                <td>4.</td>
                                <td>Fix and squish bugs</td>
                                <td>
                                  <div class="progress progress-xs progress-striped active">
                                    <div class="progress-bar bg-success" style="width: 90%"></div>
                                  </div>
                                </td>
                                <td><span class="badge bg-success">90%</span></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="chart-wrapper">
                        
                      </div>
                    <div class="col-5">
                      <div class="info-box mb-3 bg-warning">
                        <span class="info-box-icon"><i class="fas fa-tag"></i></span>
          
                        <div class="info-box-content">
                          <span class="info-box-text">Inventory</span>
                          <span class="info-box-number">5,200</span>
                        </div>                         
                      </div>

                      <div class="info-box mb-3 bg-success">
                        <span class="info-box-icon"><i class="far fa-heart"></i></span>
          
                        <div class="info-box-content">
                          <span class="info-box-text">Mentions</span>
                          <span class="info-box-number">92,050</span>
                        </div>
                      </div>
                      <div class="info-box mb-3 bg-danger">
                        <span class="info-box-icon"><i class="fas fa-cloud-download-alt"></i></span>
          
                        <div class="info-box-content">
                          <span class="info-box-text">Downloads</span>
                          <span class="info-box-number">114,381</span>
                        </div>                          
                      </div>
                      <div class="info-box mb-3 bg-info">
                        <span class="info-box-icon"><i class="far fa-comment"></i></span>
          
                        <div class="info-box-content">
                          <span class="info-box-text">Direct Messages</span>
                          <span class="info-box-number">163,921</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div class="card-footer">
      
                </div>
              </div>
            </div>
          </div>
          -->

      <!-- กลุ่มชาวไร่ -->
      <!-- 
          <div class="row">
            <div class="col-12">
              <div class="card card-primary card-outline">
                <div class="card-header">
                    <p class="headText text-primary" style="font-size: xx-large;"> <i class="fas fa-users"></i> กลุ่มชาวไร่</p>
                    <span class="text-red">...อยู่ระหว่างพัฒนา</span>
                  </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-4">
                      <div class="card card-widget widget-user">                          
                        <div class="widget-user-header text-white"
                              style="background: url('../assets/images/canebrr.png') center center;">
                          <h4 class="widget-user-username text-right">Buriram Model</h4>
                          
                        </div>
                        <div class="widget-user-image">
                          <img class="img-circle" src="../assets/images/bsflogo.png" alt="brr">
                        </div>
                        <div class="card-footer">
                          <div class="row">
                            <div class="col-sm-4 border-right">
                              <div class="description-block">
                                <h5 class="description-header">999</h5>
                                <span class="description-text headText">รถตัด</span>
                              </div>
                              
                            </div>
                            
                            <div class="col-sm-4 border-right">
                              <div class="description-block">
                                <h5 class="description-header">999</h5>
                                <span class="description-text headText">คนตัด</span>
                              </div>
                              
                            </div>
                            
                            <div class="col-sm-4">
                              <div class="description-block ">
                                <h5 class="description-header">999</h5>
                                <span class="description-text headText">รถโยน</span>
                              </div>
                              
                            </div>
                            
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div class="card-footer">
      
                </div>
              </div>
            </div>
          </div>
          -->

      <!-- เทรนประเมินอ้อย -->
      <!-- 
            <div class="row">
              <div class="col-12">
                <div class="card card-primary card-outline">
                  <div class="card-header">
                      <p class="headText text-primary">Sugarcane forecasting Trends</p>
                  </div>
                  <div class="card-body">
                    <span class="text-red">...อยู่ระหว่างพัฒนา</span>
                  </div>
                  <div class="card-footer">
        
                  </div>
                </div>
              </div>
            </div>
            -->

      <!-- กราฟเดิม
              <div class="row">
                  <div class="col-md-3">
                      <div class="card card-primary card-outline">
                          <div class="card-header">
                              <p class="headText text-primary">พื้นที่ปลูก (แสนไร่)</p>
                          </div>
                          <div class="card-body mx-auto">
                              <ngx-gauge size="200" 
                                  type="arch" 
                                  thick="15" 
                                  [value]="gaugeValue | number "   
                                  cap="butt" 
                                  label="แสนไร่" 
                                  append=""
                                  min = 0
                                  max = 2.5
                                  [markers]="markerConfig">
                              </ngx-gauge>
                          </div>
                      </div>
                      <div class="card card-primary card-outline">
                          <div class="card-header">
                              <p class="headText text-primary">ปริมาณอ้อย (ตัน)</p>
                          </div>
                          <div class="card-body">
                              <div class="small-box bg-warning">
                                  <div class="inner">
                                    <h1 class="headText2">{{ caneAssessnow | number}}</h1>
                                    <p class="text-white headText">cane projection</p>
                                  </div>
                                  <div class="icon">
                                    <i class="fas fa-chart-area"></i>
                                  </div>
                                  <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
                              </div>
                          </div>
                      </div>
                      <div class="card card-primary card-outline">
                        <div class="card-header">
                            <p class="headText text-primary">ผลผลิต (ตัน/ไร่)</p>
                        </div>
                        <div class="card-body">
                            <div class="small-box bg-success">
                                <div class="inner">
                                  <h1>{{ yieldNow | number }}</h1>
                                  <p class="text-white headText">Yield</p>
                                </div>
                                <div class="icon">
                                  <i class="fas fa-hand-holding-heart"></i>
                                </div>
                                <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                  -->
      <!-- กราฟ ประเภทอ้อย -->
      <!--
                    <div class="card card-primary card-outline">
                        <div class="card-header">
                            <p class="headText text-primary">ประเภทอ้อย</p>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="card card-success card-outline ">
                                <div class="chart-wrapper">
                                  <canvas baseChart 
                                  [datasets]="dnChartData"
                                  [labels]="dnChartLabels"
                                  [options]="dnChartOptions"
                                  [plugins]="dnChartPlugins"
                                  [legend]="dnChartLegend"
                                  [chartType]="dnChartType">
                                </canvas>
                              </div> 
                            </div>
                          </div>
                            <div class="col-md-6">
                              <div class="card card-success card-outline ">
                                <div class="chart-wrapper">
                                  <canvas baseChart 
                                  [datasets]="barChart1Data"
                                  [labels]="barChart1Labels"
                                  [options]="barChart1Options"
                                  [plugins]="barChart1Plugins"
                                  [legend]="barChart1Legend"
                                  [chartType]="barChart1Type">
                                </canvas>
                              </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="card card-success card-outline ">
                                <div class="chart-wrapper">
                                  <canvas baseChart 
                                  [datasets]="lineChartData"
                                  [labels]="lineChartLabels"
                                  [options]="lineChartOptions"
                                  [plugins]="lineChartPlugins"
                                  [legend]="lineChartLegend"
                                  [chartType]="lineChartType">
                                </canvas>
                              </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="card card-success card-outline ">
                                <div class="chart-wrapper">
                                  <canvas baseChart 
                                  [datasets]="levelbarChartData"
                                  [labels]="levelbarChartLabels"
                                  [options]="levelbarChartOptions"
                                  [plugins]="levelbarChartPlugins"
                                  [legend]="levelbarChartLegend"
                                  [chartType]="levelbarChartType">
                                </canvas>
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                              <div class="col-sm-3 col-6">
                                <div class="description-block border-right">
                                  <span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 17%</span>
                                  <h5 class="description-header">$35,210.43</h5>
                                  <span class="description-text">TOTAL REVENUE</span>
                                </div>
                                
                              </div> 
                              
                              <div class="col-sm-3 col-6">
                                <div class="description-block border-right">
                                  <span class="description-percentage text-warning"><i class="fas fa-caret-left"></i> 0%</span>
                                  <h5 class="description-header">$10,390.90</h5>
                                  <span class="description-text">TOTAL COST</span>
                                </div>
                                
                              </div>
                              
                              <div class="col-sm-3 col-6">
                                <div class="description-block border-right">
                                  <span class="description-percentage text-success"><i class="fas fa-caret-up"></i> 20%</span>
                                  <h5 class="description-header">$24,813.53</h5>
                                  <span class="description-text">TOTAL PROFIT</span>
                                </div>
                                
                              </div>
                              
                              <div class="col-sm-3 col-6">
                                <div class="description-block">
                                  <span class="description-percentage text-danger"><i class="fas fa-caret-down"></i> 18%</span>
                                  <h5 class="description-header">1200</h5>
                                  <span class="description-text">GOAL COMPLETIONS</span>
                                </div>
                                
                              </div>
                            </div>-->
      <!-- /.row -->
    </div>
  </div>
</div>



<app-footer></app-footer>